import React, { useContext, useEffect, useRef, useState } from "react";
import { ChromePicker } from "react-color";
import { FireBaseContext } from "../../Context/FireBase";

const ColorPickerInput = ({ type }) => {
  const [showPicker, setShowPicker] = useState(false);
  const { newEvent, setNewEvent } = useContext(FireBaseContext);
  const [selectedColor, setSelectedColor] = useState(newEvent[type]);

  const boxRef = useRef(null);

  const handleColorChange = (color) => {
    setSelectedColor(color.hex);
    setNewEvent({ ...newEvent, [type]: color.hex });
  };

  const handleClick = () => {
    setShowPicker(!showPicker);
  };

  const handleOutsideClick = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);
  return (
    <div ref={boxRef} className="flex items-center justify-center gap-2 border border-gray-200 rounded w-75 mb-6">
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: selectedColor,
          cursor: "pointer",
          borderRadius: "5px",
        }}
        className="appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
        
        onClick={handleClick}
      ></div>
      {showPicker && (
        <ChromePicker color={selectedColor} onChange={handleColorChange} />
      )}
      <p className="m-0 p-2"> {selectedColor}</p>
    </div>
  );
};

export default ColorPickerInput;
